module.exports = __webpack_public_path__ + "static/media/fcc.86b0d0b6.png";